// hooks/useSessionRefetch.js
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import api from "./config/axiosConfig";
import { login } from "./redux/authSlice";

export const useSessionRefetch = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const verificarSesion = async () => {
      try {
        const { data } = await api.get("/auth/session");
        dispatch(
          login({
            user: data.user,
            empresas: data.empresas,
            token: data.token,
          })
        );
      } catch (error) {
        console.warn("❌ Error actualizando sesión", error);
        // Aquí podrías redirigir al login si quieres forzar re-autenticación
      }
    };

    verificarSesion();
  }, [dispatch]);
};
